import type { RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { limitTemplatesLoader } from './limit-templates-loader';

export const limitTemplatesRoutes: RouteObject = {
  loader: limitTemplatesLoader,
  children: [
    {
      path: '/admin/limit-templates',
      lazy: lazyComponent(
        () => import('@pages/tenant/limit-templates'),
        'LimitTemplatesPage',
      ),
    },
    {
      path: '/admin/limit-templates/create',
      lazy: lazyComponent(
        () => import('@pages/tenant/limit-templates'),
        'LimitTemplateCreatePage',
      ),
    },
    {
      path: '/admin/limit-templates/:id/edit',
      lazy: lazyComponent(
        () => import('@pages/tenant/limit-templates'),
        'LimitTemplateEditPage',
      ),
    },
  ],
};
